module.exports = __webpack_public_path__ + "static/media/clipboard.7e8acc91.svg";